import { render, staticRenderFns } from "./TicketsListPage.vue?vue&type=template&id=1e362191&scoped=true&"
import script from "./TicketsListPage.vue?vue&type=script&lang=ts&"
export * from "./TicketsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsListPage.vue?vue&type=style&index=0&id=1e362191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e362191",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
